import {createI18n} from 'vue-i18n';
import locals from './locale';


export default createI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: locals
});